import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import { motion, AnimatePresence } from "framer-motion";

const OfficeUserManager = () => {
  const [offices, setOffices] = useState([]);
  const [staff, setStaff] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState("");
  const [loading, setLoading] = useState(false);
  const [staffLoading, setStaffLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    item: null,
    type: "office",
  });
  const [editModal, setEditModal] = useState({ 
    isOpen: false, 
    office: null 
  });

  // Form states
  const [officeName, setOfficeName] = useState("");
  const [officeAddress, setOfficeAddress] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const [editOfficeName, setEditOfficeName] = useState("");
  const [editOfficeAddress, setEditOfficeAddress] = useState("");
  const [editOfficePhone, setEditOfficePhone] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editOffice, setEditOffice] = useState("");
  const [editPassword, setEditPassword] = useState("");

  const token = localStorage.getItem("token");

  // SVG Icons
  const Icons = {
    Building: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    UserPlus: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
      </svg>
    ),
    Users: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5 5.197a6 6 0 00-9-5.197M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    Pencil: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
      </svg>
    ),
    Trash: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    ),
    Refresh: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    ),
    Plus: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
    ),
    Close: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
    Check: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
    Warning: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.5 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
    ),
    UserCircle: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    Phone: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
    ),
    MapPin: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    Email: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    Key: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
      </svg>
    ),
    User: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    )
  };

  // Helper function to show messages
  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
  };

  // Helper function to extract message from API response
  const extractMessage = (response) => {
    if (response.data?.message) {
      return response.data.message;
    }
    if (response.data?.errors) {
      const errorMessages = Object.values(response.data.errors).flat();
      return errorMessages.join(", ") || "Validation error";
    }
    if (response.data?.error) {
      return response.data.error;
    }
    return response.status === 200 ? "Operation successful" : "Operation failed";
  };

  // Helper function to check if response is successful
  const isSuccessResponse = (response) => {
    const status = response.status;
    const data = response.data;
    
    // Check HTTP status
    if (status >= 200 && status < 300) {
      // Check response data structure
      if (data?.success === true || data?.status === "success") {
        return true;
      }
      // For PATCH/DELETE with direct success message
      if (data?.message?.includes("successfully")) {
        return true;
      }
      // For create office success
      if (data?.data?.id && data?.message) {
        return true;
      }
      return true; // Default to true for 2xx status
    }
    return false;
  };

  // Validation functions
  const validateOfficeFields = () => {
    if (!officeName.trim()) {
      showMessage("Office name is required", "error");
      return false;
    }
    if (!officeAddress.trim()) {
      showMessage("Office address is required", "error");
      return false;
    }
    if (!officePhone.trim()) {
      showMessage("Phone number is required", "error");
      return false;
    }
    if (!/^\d{10}$/.test(officePhone.trim())) {
      showMessage("Please enter a valid 10-digit phone number", "error");
      return false;
    }
    return true;
  };

  const validateUserFields = () => {
    if (!selectedOffice) {
      showMessage("Please select an office", "error");
      return false;
    }
    if (!userName.trim()) {
      showMessage("Full name is required", "error");
      return false;
    }
    if (!userEmail.trim()) {
      showMessage("Email is required", "error");
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail.trim())) {
      showMessage("Please enter a valid email address", "error");
      return false;
    }
    if (!userPassword.trim()) {
      showMessage("Password is required", "error");
      return false;
    }
    if (userPassword.length < 6) {
      showMessage("Password must be at least 6 characters", "error");
      return false;
    }
    return true;
  };

  const validateEditOfficeFields = () => {
    if (!editOfficeName.trim()) {
      showMessage("Office name is required", "error");
      return false;
    }
    if (!editOfficeAddress.trim()) {
      showMessage("Office address is required", "error");
      return false;
    }
    if (!editOfficePhone.trim()) {
      showMessage("Phone number is required", "error");
      return false;
    }
    if (!/^\d{10}$/.test(editOfficePhone.trim())) {
      showMessage("Please enter a valid 10-digit phone number", "error");
      return false;
    }
    return true;
  };

  // Fetch offices
  const fetchOffices = async () => {
    try {
      const response = await axios.get(`${API_URL}getOfficesList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status === "success") {
        setOffices(response.data.data || []);
      } else {
        showMessage("Failed to fetch offices", "error");
      }
    } catch (error) {
      console.error("Error fetching offices:", error);
      showMessage("Error fetching offices", "error");
    }
  };

  // Fetch staff list
  const fetchStaff = async () => {
    setStaffLoading(true);
    try {
      const response = await axios.get(`${API_URL}getStaffList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.status === "success") {
        setStaff(response.data.data || []);
      } else {
        showMessage("Failed to fetch staff", "error");
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      showMessage("Error fetching staff list", "error");
    }
    setStaffLoading(false);
  };

  useEffect(() => {
    fetchOffices();
    fetchStaff();
  }, []);

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => setMessage({ text: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  // ============ OFFICE CRUD OPERATIONS ============

  const handleCreateOffice = async (e) => {
    e.preventDefault();
    if (!validateOfficeFields()) return;
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}createOffice`,
        {
          name: officeName.trim(),
          address: officeAddress.trim(),
          phone: officePhone.trim(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setOfficeName("");
        setOfficeAddress("");
        setOfficePhone("");
        fetchOffices();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error creating office:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error creating office", "error");
      }
    }
    setLoading(false);
  };

  const handleUpdateOffice = async (e) => {
    e.preventDefault();
    if (!validateEditOfficeFields()) return;
    setLoading(true);
    try {
      const response = await axios.patch(
        `${API_URL}office/${editModal.office.id}`,
        {
          name: editOfficeName.trim(),
          address: editOfficeAddress.trim(),
          phone: editOfficePhone.trim(),
        },
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setEditModal({ isOpen: false, office: null });
        setEditOfficeName("");
        setEditOfficeAddress("");
        setEditOfficePhone("");
        fetchOffices();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error updating office:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error updating office", "error");
      }
    }
    setLoading(false);
  };

  const handleDeleteOffice = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        `${API_URL}deleteOffice/${deleteModal.item.id}`,
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          data: {
            name: deleteModal.item.name,
            address: deleteModal.item.address || "",
            phone: deleteModal.item.phone || "",
          }
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setDeleteModal({ isOpen: false, item: null, type: "office" });
        fetchOffices();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error deleting office:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error deleting office", "error");
      }
    }
    setLoading(false);
  };

  const openEditOfficeModal = (office) => {
    setEditModal({ isOpen: true, office });
    setEditOfficeName(office.name);
    setEditOfficeAddress(office.address || "");
    setEditOfficePhone(office.phone || "");
  };

  // ============ USER OPERATIONS ============

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if (!validateUserFields()) return;
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}create`,
        {
          name: userName.trim(),
          email: userEmail.trim(),
          password: userPassword,
          office_id: selectedOffice,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setUserName("");
        setUserEmail("");
        setUserPassword("");
        setSelectedOffice("");
        fetchStaff();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error creating user", "error");
      }
    }
    setLoading(false);
  };

  const handleEditStaff = async (e) => {
    e.preventDefault();
    if (!editName.trim()) {
      showMessage("Staff name is required", "error");
      return;
    }
    if (!editOffice) {
      showMessage("Please select an office", "error");
      return;
    }
    if (editPassword && editPassword.length < 6) {
      showMessage("Password must be at least 6 characters", "error");
      return;
    }
    
    setLoading(true);
    try {
      const requestData = {
        email: editEmail.trim(),
        name: editName.trim(),
        office_id: editOffice,
      };
      
      if (editPassword.trim()) {
        requestData.password = editPassword;
      }
      
      const response = await axios.post(
        `${API_URL}editStaff`,
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setDeleteModal({ isOpen: false, item: null, type: "" });
        setEditName("");
        setEditEmail("");
        setEditOffice("");
        setEditPassword("");
        fetchStaff();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error updating staff:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error updating staff member", "error");
      }
    }
    setLoading(false);
  };

  const handleDeleteStaff = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}deleteStaff`,
        {
          email: deleteModal.item.email,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      if (isSuccessResponse(response)) {
        const msg = extractMessage(response);
        showMessage(msg, "success");
        setDeleteModal({ isOpen: false, item: null, type: "" });
        fetchStaff();
      } else {
        const msg = extractMessage(response);
        showMessage(msg, "error");
      }
    } catch (error) {
      console.error("Error deleting staff:", error);
      if (error.response) {
        const msg = extractMessage(error.response);
        showMessage(msg, "error");
      } else if (error.request) {
        showMessage("Network error. Please try again.", "error");
      } else {
        showMessage("Error deleting staff member", "error");
      }
    }
    setLoading(false);
  };

  const openEditStaffModal = (staff) => {
    setDeleteModal({ 
      isOpen: true, 
      item: staff, 
      type: "editStaff" 
    });
    setEditName(staff.staff_name);
    setEditEmail(staff.email);
    setEditOffice(offices.find((o) => o.name === staff.office_name)?.id || "");
  };

  // Function to generate random gradient for office cards
  const getOfficeGradient = (id) => {
    const gradients = [
      "from-blue-500 to-cyan-400",
      "from-purple-500 to-pink-400",
      "from-green-500 to-emerald-400",
      "from-orange-500 to-yellow-400",
      "from-indigo-500 to-blue-400",
      "from-rose-500 to-pink-400"
    ];
    return gradients[id % gradients.length];
  };

  const getStaffGradient = (index) => {
    const gradients = [
      "from-blue-500 to-cyan-400",
      "from-purple-500 to-pink-400",
      "from-emerald-500 to-teal-400"
    ];
    return gradients[index % gradients.length];
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6">
      {/* Header */}
      <motion.div 
        className="max-w-7xl mx-auto mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
              Office & User Management
            </h1>
            <p className="text-gray-600 mt-2">Manage offices and staff members efficiently</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={fetchOffices}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow"
            >
              <Icons.Refresh />
              Refresh Offices
            </button>
            <button
              onClick={fetchStaff}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow"
            >
              <Icons.Refresh />
              Refresh Staff
            </button>
          </div>
        </div>
      </motion.div>

      {/* Message Alert */}
      <AnimatePresence>
        {message.text && (
          <motion.div
            className="max-w-7xl mx-auto mb-6"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
          >
            <div className={`flex items-center gap-3 p-4 rounded-xl border-l-4 shadow-sm ${
              message.type === "success" 
                ? "bg-green-50 border-green-500 text-green-700" 
                : "bg-red-50 border-red-500 text-red-700"
            }`}>
              {message.type === "success" ? (
                <Icons.Check />
              ) : (
                <Icons.Warning />
              )}
              <span className="font-medium">{message.text}</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* LEFT COLUMN */}
        <div className="space-y-6">
          {/* Create Office Card */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="p-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 rounded-lg bg-gradient-to-r from-emerald-500 to-teal-400">
                  <Icons.Building />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">Create New Office</h3>
                  <p className="text-gray-500 text-sm">Add a new office location</p>
                </div>
              </div>
              
              <form onSubmit={handleCreateOffice} className="space-y-4">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Office Name <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute left-3 top-3.5">
                      <Icons.Building />
                    </div>
                    <input
                      type="text"
                      placeholder="e.g., New Delhi Office"
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all duration-200"
                      value={officeName}
                      onChange={(e) => setOfficeName(e.target.value)}
                      required
                    />
                  </div>
                </div>
                
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Office Address <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute left-3 top-3.5">
                      <Icons.MapPin />
                    </div>
                    <input
                      type="text"
                      placeholder="e.g., Saket, Delhi"
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all duration-200"
                      value={officeAddress}
                      onChange={(e) => setOfficeAddress(e.target.value)}
                      required
                    />
                  </div>
                </div>
                
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute left-3 top-3.5">
                      <Icons.Phone />
                    </div>
                    <input
                      type="tel"
                      placeholder="9999999999"
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all duration-200"
                      value={officePhone}
                      onChange={(e) => setOfficePhone(e.target.value)}
                      maxLength="10"
                      required
                    />
                  </div>
                </div>
                
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full mt-6 py-3.5 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold rounded-xl hover:from-emerald-600 hover:to-teal-600 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <Icons.Refresh className="animate-spin" />
                      Creating Office...
                    </>
                  ) : (
                    <>
                      <Icons.Plus />
                      Create Office
                    </>
                  )}
                </button>
              </form>
            </div>
          </motion.div>

          {/* Offices List Card */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 }}
          >
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-400">
                    <Icons.Building />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">Office List</h3>
                    <p className="text-gray-500 text-sm">{offices.length} office(s)</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    offices.length > 0 
                      ? "bg-green-100 text-green-700" 
                      : "bg-gray-100 text-gray-700"
                  }`}>
                    {offices.length} Active
                  </span>
                </div>
              </div>

              {offices.length === 0 ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 flex items-center justify-center">
                    <Icons.Building className="w-10 h-10 text-gray-400" />
                  </div>
                  <h4 className="text-lg font-semibold text-gray-700 mb-2">No Offices Yet</h4>
                  <p className="text-gray-500">Create your first office to get started</p>
                </div>
              ) : (
                <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
                  {offices.map((office) => (
                    <motion.div
                      key={office.id}
                      className="group relative bg-gradient-to-r from-white to-gray-50 border border-gray-200 rounded-xl p-4 hover:border-blue-300 transition-all duration-200 hover:shadow-md"
                      whileHover={{ scale: 1.005 }}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className={`p-3 rounded-lg bg-gradient-to-r ${getOfficeGradient(office.id)}`}>
                            <Icons.Building className="w-5 h-5 text-white" />
                          </div>
                          <div>
                            <h4 className="font-bold text-gray-800 text-lg">{office.name}</h4>
                            <div className="flex items-center gap-3 mt-2">
                              <span className="px-2.5 py-0.5 bg-blue-50 text-blue-700 text-xs font-medium rounded-full border border-blue-100">
                                ID: {office.id}
                              </span>
                              <span className="px-2.5 py-0.5 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-full border border-emerald-100">
                                Active
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                          <button
                            onClick={() => openEditOfficeModal(office)}
                            className="p-2 rounded-lg bg-gradient-to-r from-blue-50 to-blue-100 text-blue-600 hover:from-blue-100 hover:to-blue-200 border border-blue-200 hover:border-blue-300 transition-all duration-200 hover:shadow-sm"
                            title="Edit Office"
                          >
                            <Icons.Pencil />
                          </button>
                          <button
                            onClick={() => setDeleteModal({ isOpen: true, item: office, type: "office" })}
                            className="p-2 rounded-lg bg-gradient-to-r from-red-50 to-red-100 text-red-600 hover:from-red-100 hover:to-red-200 border border-red-200 hover:border-red-300 transition-all duration-200 hover:shadow-sm"
                            title="Delete Office"
                          >
                            <Icons.Trash />
                          </button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="space-y-6">
          {/* Create User Card */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="p-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-400">
                  <Icons.UserPlus />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">Create New Staff</h3>
                  <p className="text-gray-500 text-sm">Add staff members to offices</p>
                </div>
              </div>
              
              <form onSubmit={handleCreateUser} className="space-y-4">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Office <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute left-3 top-3.5">
                      <Icons.Building />
                    </div>
                    <select
                      value={selectedOffice}
                      onChange={(e) => setSelectedOffice(e.target.value)}
                      className="w-full pl-11 pr-10 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 appearance-none bg-white"
                      required
                    >
                      <option value="">Choose an office...</option>
                      {offices.map((office) => (
                        <option key={office.id} value={office.id}>{office.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute left-3 top-3.5">
                        <Icons.User />
                      </div>
                      <input
                        type="text"
                        placeholder="John Doe"
                        className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute left-3 top-3.5">
                        <Icons.Email />
                      </div>
                      <input
                        type="email"
                        placeholder="john@example.com"
                        className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Password <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute left-3 top-3.5">
                      <Icons.Key />
                    </div>
                    <input
                      type="password"
                      placeholder="••••••••"
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                      value={userPassword}
                      onChange={(e) => setUserPassword(e.target.value)}
                      minLength="6"
                      required
                    />
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Minimum 6 characters</p>
                </div>
                
                <button
                  type="submit"
                  disabled={loading || !selectedOffice}
                  className="w-full mt-6 py-3.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-xl hover:from-purple-600 hover:to-pink-600 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <Icons.Refresh className="animate-spin" />
                      Creating User...
                    </>
                  ) : (
                    <>
                      <Icons.UserPlus />
                      Create Staff Member
                    </>
                  )}
                </button>
              </form>
            </div>
          </motion.div>

          {/* Staff Members Card */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 }}
          >
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-gradient-to-r from-amber-500 to-orange-400">
                    <Icons.Users />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">Staff Members</h3>
                    <p className="text-gray-500 text-sm">{staff.length} staff member(s)</p>
                  </div>
                </div>
                <button
                  onClick={fetchStaff}
                  disabled={staffLoading}
                  className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 hover:from-amber-100 hover:to-orange-100 border border-amber-200 hover:border-amber-300 transition-all duration-200 disabled:opacity-50"
                >
                  {staffLoading ? (
                    <Icons.Refresh className="animate-spin" />
                  ) : (
                    <Icons.Refresh />
                  )}
                  Refresh
                </button>
              </div>

              {staffLoading ? (
                <div className="text-center py-12">
                  <Icons.Refresh className="w-12 h-12 mx-auto text-amber-500 animate-spin" />
                  <p className="mt-4 text-gray-500">Loading staff members...</p>
                </div>
              ) : staff.length === 0 ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-r from-amber-100 to-orange-100 flex items-center justify-center">
                    <Icons.Users className="w-10 h-10 text-amber-500" />
                  </div>
                  <h4 className="text-lg font-semibold text-gray-700 mb-2">No Staff Members</h4>
                  <p className="text-gray-500">Create your first staff member above</p>
                </div>
              ) : (
                <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
                  {staff.map((staffMember, index) => (
                    <motion.div
                      key={staffMember.email}
                      className="group bg-gradient-to-r from-white to-gray-50 border border-gray-200 rounded-xl p-4 hover:border-amber-300 transition-all duration-200 hover:shadow-md"
                      whileHover={{ scale: 1.005 }}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className="relative">
                            <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg bg-gradient-to-r ${getStaffGradient(index)}`}>
                              {staffMember.staff_name?.charAt(0)?.toUpperCase() || "U"}
                            </div>
                            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full border-2 border-white flex items-center justify-center">
                              <Icons.UserCircle className="w-3 h-3 text-white" />
                            </div>
                          </div>
                          <div>
                            <h4 className="font-bold text-gray-800">{staffMember.staff_name || "Unnamed"}</h4>
                            <p className="text-gray-500 text-sm mt-1">{staffMember.email}</p>
                            <div className="flex items-center gap-2 mt-2">
                              <span className="px-2.5 py-0.5 bg-gradient-to-r from-emerald-50 to-teal-50 text-emerald-700 text-xs font-medium rounded-full border border-emerald-100">
                                {staffMember.office_name || "No Office"}
                              </span>
                              <span className="px-2.5 py-0.5 bg-blue-50 text-blue-700 text-xs font-medium rounded-full border border-blue-100">
                                Staff
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => openEditStaffModal(staffMember)}
                            className="p-2 rounded-lg bg-gradient-to-r from-blue-50 to-blue-100 text-blue-600 hover:from-blue-100 hover:to-blue-200 border border-blue-200 hover:border-blue-300 transition-all duration-200 hover:shadow-sm opacity-0 group-hover:opacity-100"
                            title="Edit Staff"
                          >
                            <Icons.Pencil />
                          </button>
                          <button
                            onClick={() => setDeleteModal({ isOpen: true, item: staffMember, type: "staff" })}
                            className="p-2 rounded-lg bg-gradient-to-r from-red-50 to-red-100 text-red-600 hover:from-red-100 hover:to-red-200 border border-red-200 hover:border-red-300 transition-all duration-200 hover:shadow-sm opacity-0 group-hover:opacity-100"
                            title="Delete Staff"
                          >
                            <Icons.Trash />
                          </button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Modals */}
      <AnimatePresence>
        {/* Edit Office Modal */}
        {editModal.isOpen && (
          <Modal onClose={() => setEditModal({ isOpen: false, office: null })}>
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-400">
                <Icons.Pencil />
              </div>
              <h3 className="text-xl font-bold text-gray-800">Edit Office</h3>
            </div>
            <form onSubmit={handleUpdateOffice} className="space-y-4">
              <Input
                icon={Icons.Building}
                label="Office Name"
                value={editOfficeName}
                onChange={setEditOfficeName}
                required
              />
              <Input
                icon={Icons.MapPin}
                label="Address"
                value={editOfficeAddress}
                onChange={setEditOfficeAddress}
                required
              />
              <Input
                icon={Icons.Phone}
                label="Phone"
                type="tel"
                value={editOfficePhone}
                onChange={setEditOfficePhone}
                maxLength="10"
                required
              />
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEditModal({ isOpen: false, office: null })}
                  className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-5 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold hover:from-blue-600 hover:to-cyan-600 transition-all duration-200 disabled:opacity-50"
                >
                  {loading ? "Updating..." : "Update Office"}
                </button>
              </div>
            </form>
          </Modal>
        )}

        {/* Delete Confirmation Modal */}
        {deleteModal.isOpen && deleteModal.type !== "editStaff" && (
          <Modal onClose={() => setDeleteModal({ isOpen: false, item: null, type: "" })}>
            <div className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-r from-red-100 to-pink-100 flex items-center justify-center">
                <Icons.Warning className="w-10 h-10 text-red-500" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Deletion</h3>
              <p className="text-gray-600 mb-6">
                Are you sure you want to delete{" "}
                <span className="font-semibold text-gray-800">
                  {deleteModal.type === "office" 
                    ? deleteModal.item?.name 
                    : deleteModal.item?.staff_name}
                </span>
                ? This action cannot be undone.
              </p>
              <div className="flex justify-center gap-3">
                <button
                  onClick={() => setDeleteModal({ isOpen: false, item: null, type: "" })}
                  className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={deleteModal.type === "office" ? handleDeleteOffice : handleDeleteStaff}
                  disabled={loading}
                  className="px-6 py-3 rounded-xl bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold hover:from-red-600 hover:to-pink-600 transition-all duration-200 disabled:opacity-50"
                >
                  {loading ? "Deleting..." : "Yes, Delete"}
                </button>
              </div>
            </div>
          </Modal>
        )}

        {/* Edit Staff Modal */}
        {deleteModal.isOpen && deleteModal.type === "editStaff" && (
          <Modal onClose={() => setDeleteModal({ isOpen: false, item: null, type: "" })}>
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-400">
                <Icons.UserCircle />
              </div>
              <h3 className="text-xl font-bold text-gray-800">Edit Staff Member</h3>
            </div>
            <form onSubmit={handleEditStaff} className="space-y-4">
              <Input
                icon={Icons.User}
                label="Staff Name"
                value={editName}
                onChange={setEditName}
                required
              />
              <Input
                icon={Icons.Email}
                label="Email"
                value={editEmail}
                disabled
              />
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Office</label>
                <div className="relative">
                  <div className="absolute left-3 top-3.5">
                    <Icons.Building />
                  </div>
                  <select
                    value={editOffice}
                    onChange={(e) => setEditOffice(e.target.value)}
                    className="w-full pl-11 pr-10 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 appearance-none bg-white"
                    required
                  >
                    <option value="">Select an office</option>
                    {offices.map((office) => (
                      <option key={office.id} value={office.id}>{office.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <Input
                icon={Icons.Key}
                label="New Password (optional)"
                type="password"
                value={editPassword}
                onChange={setEditPassword}
                placeholder="Leave blank to keep current"
              />
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setDeleteModal({ isOpen: false, item: null, type: "" })}
                  className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-5 py-2.5 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold hover:from-purple-600 hover:to-pink-600 transition-all duration-200 disabled:opacity-50"
                >
                  {loading ? "Updating..." : "Update Staff"}
                </button>
              </div>
            </form>
          </Modal>
        )}
      </AnimatePresence>
    </div>
  );
};

// Reusable Modal Component
const Modal = ({ children, onClose }) => (
  <motion.div
    className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 backdrop-blur-sm"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <motion.div
      className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl"
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0.9, opacity: 0 }}
    >
      <button
        onClick={onClose}
        className="absolute right-4 top-4 p-1 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      {children}
    </motion.div>
  </motion.div>
);

// Reusable Input Component
const Input = ({ icon: Icon, label, value, onChange, type = "text", disabled = false, required = false, ...props }) => (
  <div className="space-y-2">
    <label className="block text-sm font-medium text-gray-700">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <div className="relative">
      <div className="absolute left-3 top-3.5">
        <Icon className="w-5 h-5 text-gray-400" />
      </div>
      <input
        type={type}
        className={`w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ${
          disabled ? "bg-gray-50 text-gray-500" : "bg-white"
        }`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
        {...props}
      />
    </div>
  </div>
);

export default OfficeUserManager;